document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.timeline__content p').forEach(function(element) {
    element.addEventListener('click', function() {
      // Überprüfen, ob die Eigenschaften bereits gesetzt sind
      if (element.style.whiteSpace === 'normal') {
        // Eigenschaften zurücksetzen
        element.style.whiteSpace = '';
        element.style.overflow = '';
        element.style.textOverflow = '';
      } else {
        // Eigenschaften setzen
        element.style.whiteSpace = 'normal';
        element.style.overflow = 'auto';
        element.style.textOverflow = 'inherit';
      }
    });
  });
});








document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.open-mainmenu').forEach(function(element) {
        element.addEventListener('click', function() {
            const mobileMenuDrawer = document.getElementById('mobile-menu-drawer');
            if (mobileMenuDrawer) {
                mobileMenuDrawer.setAttribute('open', '');
            }
        });
    });
  
});


document.addEventListener('DOMContentLoaded', function () {
  // Alle Elemente mit der Klasse '.jf-megamenu-tr' auswählen
  const triggerElements = document.querySelectorAll('.jf-megamenu-tr');

  // Für jedes Trigger-Element ein Mouseover-Event registrieren
  triggerElements.forEach(function (element) {
    const megaMenuId = element.getAttribute('mega-menu-ref');
    const megaMenu = document.getElementById(megaMenuId);
    
    if (megaMenu) {
      element.addEventListener('mouseenter', function () {
        megaMenu.style.display = 'block';
      });
      
      megaMenu.addEventListener('mouseleave', function () {
        megaMenu.style.display = 'none';
      });
      
      element.addEventListener('mouseleave', function () {
        setTimeout(() => {
          if (!megaMenu.matches(':hover')) {
            megaMenu.style.display = 'none';
          }
        }, 200); // Verzögerung, um versehentliches Ausblenden zu verhindern
      });
    } else {
      console.error(`Kein Mega-Menü mit der ID ${megaMenuId} gefunden.`);
    }
  });
});




document.addEventListener("DOMContentLoaded", () => {
    // Erstelle den schwarzen, durchsichtigen Backdrop
    const backdrop = document.createElement("div");
    backdrop.style.position = "fixed";
    backdrop.style.top = "0";
    backdrop.style.left = "0";
    backdrop.style.width = "100vw";
    backdrop.style.height = "100vh";
    backdrop.style.backgroundColor = "rgba(218,235,235,0.73)";
    backdrop.style.backdropFilter = "blur(10px)";
    backdrop.style.display = "none";
    backdrop.style.zIndex = "999";
    document.body.appendChild(backdrop);

    // Suche das GPSR Compliance Wrapper Element
    const gpsrWrapper = document.querySelector(".gpsr-compliance-wrapper");
    if (!gpsrWrapper) {
        console.error("Element mit der Klasse 'gpsr-compliance-wrapper' wurde nicht gefunden.");
        return;
    }

    // Styles für das Popup setzen
    gpsrWrapper.style.position = "fixed";
    gpsrWrapper.style.top = "50%";
    gpsrWrapper.style.left = "50%";
    gpsrWrapper.style.transform = "translate(-50%, -50%)";
    gpsrWrapper.style.zIndex = "1000";
    gpsrWrapper.style.display = "none";

    // Close Button hinzufügen
    const closeButton = document.createElement("button");
    closeButton.textContent = "X";
    closeButton.style.position = "absolute";
    closeButton.style.top = "20px";
    closeButton.style.right = "40px";
    closeButton.style.background = "none";
    closeButton.style.border = "none";
    closeButton.style.color = "#000";
    closeButton.style.fontSize = "20px";
    closeButton.style.cursor = "pointer";
    gpsrWrapper.appendChild(closeButton);

    // Funktion zum Deaktivieren des Scrollens
    const disableScroll = () => {
        document.body.style.overflow = "hidden";
    };

    // Funktion zum Aktivieren des Scrollens
    const enableScroll = () => {
        document.body.style.overflow = "";
    };

    // Event Listener für das Anzeigen des Popups
    document.querySelectorAll(".show-gpsr").forEach(element => {
        element.addEventListener("click", () => {
            backdrop.style.display = "block";
            gpsrWrapper.style.display = "block";
            disableScroll();
        });
    });

    // Event Listener für das Schließen des Popups durch den Backdrop
    backdrop.addEventListener("click", () => {
        backdrop.style.display = "none";
        gpsrWrapper.style.display = "none";
        enableScroll();
    });

    // Event Listener für das Schließen des Popups durch den Schließen-Button
    closeButton.addEventListener("click", () => {
        backdrop.style.display = "none";
        gpsrWrapper.style.display = "none";
        enableScroll();
    });



});


function updateScrolledState() {
    if (window.scrollY > 0) {
        document.body.classList.add("user-scrolled");
    } else {
        document.body.classList.remove("user-scrolled");
    }
}

document.addEventListener("DOMContentLoaded", updateScrolledState);
document.addEventListener("scroll", updateScrolledState, { passive: true });




  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a.mega-menu-link').forEach(function (a) {
      // NBSPs entfernen und trimmen
      var text = (a.textContent || '').replace(/\u00A0/g, ' ').trim();
      if (text === '') {
        a.style.display = 'none';
      }
    });
  });
